<div class="filter-block" *ngIf="isFilterVisible">
  <div class="application-block flex-container">
    <div class="ng-select-container">
      <ion-label class="title"> {{ 'Filter' | translate}}* </ion-label>
      <ng-select placeholder="{{ 'Select Filter' | translate}}" [appendTo]="'body'" [items]="attributes" bindLabel="label"
        bindValue="value" [(ngModel)]="selectedApplication" [clearable]="false" [searchable]="true"
        (change)="onApplicationChange($event)">
        <ng-template let-item="item">
          {{item.label}}
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="operator-block flex-container">
    <div class="ng-select-container">
      <ion-label class="title"> {{ 'Operator' | translate}}*</ion-label>
      <ng-select placeholder="{{ 'Select Operator' | translate}}" [appendTo]="'body'" [items]="operatorList" bindLabel="label"
        bindValue="value" [clearable]="false" [(ngModel)]="selectedOperator" [searchable]="true"
        (change)="onOpratoerChange($event)">
        <ng-template let-item="item">
          {{item.label}}
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="value-block flex-container">
    <div class="ng-select-container">
      <ion-label class="title"> {{ 'Value' | translate}}*</ion-label>
      <ng-select placeholder="{{ 'Select Value' | translate}}" [appendTo]="'body'" [items]="values" bindLabel="value" bindValue="value"
        [clearable]="false" [(ngModel)]="selectedValue" [searchable]="true" (change)="onValueChange($event)"
        [typeahead]="selectedApplication === 'customernames' ? customerInput$ : null"
        [loading]="selectedApplication === 'customernames' && customerLoading" [loadingText]="'loading' | translate"
        (scrollToEnd)="fetchMoreCustomers()"
        [disabled]="!selectedApplication">
        <ng-template ng-notfound-tmp>
          <div class="ng-option ng-option-disabled"
            *ngIf="selectedApplication !== 'customernames' || (customerSearchCompleted && !customerLoading)">
            {{ 'No Item Found' | translate }}
          </div>
        </ng-template>
        <ng-template let-item="item">
          {{item.value}}
        </ng-template>
      </ng-select>
    </div>
  </div>
  <div class="button-container">
    <ion-button class="app-btn apply-btn" shape="round" fill="outline" color="primary" (click)="apply()"
      [disabled]="!areAllFieldsFilled()">
      {{'Apply'|translate}}
    </ion-button>
    <ion-button class="app-btn close-btn" shape="round" fill="outline" color="primary" (click)="cancel()">
      {{'Close'|translate}}
    </ion-button>
  </div>
</div>